import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import useFetch from '../../../hooks/useFetch';

import {
    getPaymentForms,
    getPaymentForm,
    addEditPaymentForm,
    deletePaymentForm
} from '../../../redux/methods/paymentForms';

import ContainerWithCard from '../../ContainerWithCard';
import TableGenerator from '../../generators/TableGenerator';
import PaymentFormEditionModal from '../../modals/PaymentFormEditionModal';
import { Button } from 'reactstrap';

import styles from './index.module.scss';
import { formUtilsHocPropTypes } from '../../../propTypes';
import { withFormUtils } from '../../../hoc/withFormUtils';

const propTypes = {
    utils: formUtilsHocPropTypes,
    isConnectedToERP: PropTypes.bool,
    getPaymentForms: PropTypes.func,
    getPaymentForm: PropTypes.func,
    addEditPaymentForm: PropTypes.func,
    deletePaymentForm: PropTypes.func,
    forceRefetch: PropTypes.bool
};

const PaymentFormsTable = ({
    utils,
    isConnectedToERP,
    getPaymentForms,
    getPaymentForm,
    addEditPaymentForm,
    deletePaymentForm,
    forceRefetch }) => {
    const intl = useIntl();
    const translations = intl.messages.paymentForms.formsTable;

    const { headers, editModal } = translations;

    const [ isEditModalOpen, setIsEditModalOpen ] = useState(false);
    const [ editModalItem, setEditModalItem ] = useState(null);

    const [ items ] = useFetch(getPaymentForms, null, [], forceRefetch);

    const editAction = id => async () => {
        const item = await getPaymentForm({ paymentFormId: id});
        if (item && item.payload && !item.payload.errors && !item.error) {
            setEditModalItem(item.payload);
            setIsEditModalOpen(true);
        }
    };

    const deleteAction = id => async () => {
        await deletePaymentForm({ paymentFormId: id});
    };

    const handleEditAction = form => {
        const objectToSend = {
            ...form,
            paymentFormId: form.id};

        /*
        if (!objectToSend.productId) {
            utils.error(translations.errors.productIdIsRequired);
            return;
        }
        else */

        if (isConnectedToERP && !objectToSend.wfMagFormId) {
            utils.error(translations.errors.wfMagFormIdIsRequired);
            return;
        }
        else {
            addEditPaymentForm(objectToSend);
            setIsEditModalOpen(false);
        }
    };

    const handleAddAction = async () => {
        const item = await getPaymentForm({paymentFormId: 0});
        if (item && item.payload && !item.payload.errors && !item.error) {
            setEditModalItem(item.payload);
            setIsEditModalOpen(true);
        }
    };

    return items ? (
        <ContainerWithCard title={translations.title} iconClass='fa fa-wallpaper'>
            <TableGenerator
                items={items}
                expectedActions={['edit', 'delete']}
                actions={{editAction, deleteAction}}
                defaultAction={editAction}
                translations={translations}
                columns={[
                    {
                        header: headers.name,
                        value: 'name',
                    },
                    {
                        header: headers.paymentMethod,
                        value: 'paymentMethod',
                    },
                    {
                        header: headers.productName,
                        value: 'productName',
                    },
                    isConnectedToERP &&
                    {
                        header: headers.wfMagFormName,
                        value: 'wfMagFormName',
                    },
                    {
                        header: headers.actions,
                        type: 'actions'
                    }
                ]}
            />
            <aside className={styles.footer}>
                <Button color='primary' onClick={handleAddAction}>
                    <i className='fa fa-plus mr-2'/>
                    <span>{translations.buttons.create}</span>
                </Button>
            </aside>
            <PaymentFormEditionModal
                isOpen={isEditModalOpen}
                setIsOpen={setIsEditModalOpen}
                translations={editModal}
                paymentForm={editModalItem}
                onSubmit={handleEditAction}
            />
        </ContainerWithCard>
    ) : null;
};

PaymentFormsTable.propTypes = propTypes;

const mapStateToProps = state => ({
    isConnectedToERP: state.appInit.isConnectedToERP,
    forceRefetch: state.refetchers.paymentForms,
});

const mapDispatch = {
    getPaymentForms,
    getPaymentForm,
    addEditPaymentForm,
    deletePaymentForm
};

export default withFormUtils(withRouter(connect(mapStateToProps, mapDispatch)(PaymentFormsTable)));